import { Navigate, useLocation } from 'react-router-dom'
import ContentPage from '@/components/ContentPage'
import { getBusinessType } from '@/content/businessTypes'

export default function BusinessTypePage({ slug: slugProp }) {
  const { pathname } = useLocation()
  const slug = slugProp || pathname.replace(/^\//, '')
  const business = getBusinessType(slug)

  if (!business) {
    return <Navigate to="/" replace />
  }

  return (
    <ContentPage
      path={business.path}
      seoTitle={business.seoTitle}
      seoDescription={business.seoDescription}
      heroTitle={business.title}
      heroDescription={business.intro}
      images={business.images}
      eyebrow="Solutions"
      sections={business.sections}
      relatedFeatureSlugs={business.relatedFeatures}
    />
  )
}
